// Staff copy the counter and reception share — the sentences lib/plan, transfer,
// move, delivered, putBack and standBy build, and the visit note and facts — in the
// three languages a branch in Azerbaijan works in.
// Native review pending (az, ru): the Azerbaijani and Russian here are a first
// draft. Change a phrase in all three languages at once, never in one.
import type { Phrase } from '../staffText'

export const floor = {
  // lib/plan.ts
  'floor.finish': { en: 'Finish', az: 'Bitir', ru: 'Завершить' },
  'floor.nextService': { en: 'Next service', az: 'Növbəti xidmət', ru: 'Следующая услуга' },
  'floor.planMax': { en: 'A visit may carry at most {n} services.', az: 'Bir müraciətdə ən çoxu {n} xidmət ola bilər.', ru: 'В одном обращении может быть не больше {n} услуг.' },
  'floor.notOfferedHere': { en: 'That service is not offered at this branch.', az: 'Bu xidmət bu filialda təklif olunmur.', ru: 'Эта услуга не предоставляется в этом отделении.' },
  'floor.alreadyOnVisit': { en: '{service} is already on this visit.', az: '{service} artıq bu müraciətdədir.', ru: '«{service}» уже есть в этом обращении.' },
  'floor.stop.desk': { en: 'This service ends here; {number} stays at this desk for {service}.', az: 'Bu xidmət burada bitir; {number} «{service}» üçün bu pəncərədə qalır.', ru: 'Эта услуга здесь завершается; {number} остаётся у этого окна для услуги «{service}».' },
  'floor.stop.queue': { en: 'This service ends here; {number} goes to the line for {service}, keeping the time they have already waited.', az: 'Bu xidmət burada bitir; {number} artıq gözlədiyi vaxtı saxlayaraq «{service}» növbəsinə keçir.', ru: 'Эта услуга здесь завершается; {number} переходит в очередь на «{service}», сохраняя время ожидания.' },
  'floor.stop.none': { en: 'This service ends here; nothing in this branch serves {service} now, so {number} has nowhere to go and their visit ends.', az: 'Bu xidmət burada bitir; hazırda bu filialda «{service}» xidməti göstərilmir, ona görə {number} üçün gediləcək yer yoxdur və müraciəti bitir.', ru: 'Эта услуга здесь завершается; сейчас в этом отделении никто не оказывает «{service}», поэтому {number} некуда направить, и обращение завершается.' },
  'floor.theNextService': { en: 'the next service', az: 'növbəti xidmət', ru: 'следующая услуга' },

  // lib/transfer.ts
  'floor.target.service': { en: 'Service', az: 'Xidmət', ru: 'Услуга' },
  'floor.target.desk': { en: 'Counter', az: 'Pəncərə', ru: 'Окно' },
  'floor.target.colleague': { en: 'Colleague', az: 'Həmkar', ru: 'Коллега' },
  'floor.place.front': { en: 'To the front', az: 'Əvvələ', ru: 'В начало' },
  'floor.place.back': { en: 'To the back', az: 'Sona', ru: 'В конец' },
  'floor.forYou': { en: 'for you', az: 'sizin üçün', ru: 'для вас' },
  'floor.forName': { en: 'for {name}', az: '{name} üçün', ru: 'для: {name}' },
  'floor.forColleague': { en: 'for a colleague', az: 'həmkar üçün', ru: 'для коллеги' },
  'floor.forAnotherDesk': { en: 'for another desk', az: 'başqa pəncərə üçün', ru: 'для другого окна' },
  'floor.forAnyDesk': { en: 'for any desk', az: 'istənilən pəncərə üçün', ru: 'для любого окна' },

  // lib/move.ts
  'floor.chooseDesk': { en: 'Choose a desk.', az: '', ru: '' },
  'floor.chooseServiceToWaitFor': { en: 'Choose the service they should wait for.', az: 'Müştərinin gözləməli olduğu xidməti seçin.', ru: 'Выберите услугу, которую клиент должен ждать.' },
  'floor.alreadyWaitingThere': { en: 'Already at the front.', az: 'Müştəri artıq həmin xidməti gözləyir. Başqa xidmət və ya növbədə başqa yer seçin.', ru: 'Клиент уже ждёт этой услуги. Выберите другую услугу или другое место в очереди.' },

  // lib/delivered.ts
  'floor.addDeliveredFirst': { en: 'Add what was delivered first: {list}.', az: 'Əvvəlcə göstərilən xidməti əlavə edin: {list}.', ru: 'Сначала добавьте оказанное: {list}.' },
  'floor.sayWhatDelivered': { en: 'Say what was delivered.', az: 'Nə göstərildiyini qeyd edin.', ru: 'Укажите, что было оказано.' },

  // lib/putBack.ts, lib/standBy.ts
  'floor.putBackQuestion': { en: 'Put {number} back in line?', az: '{number} növbəyə qaytarılsın?', ru: 'Вернуть {number} в очередь?' },
  'floor.putBackNote': { en: 'Takes them out of the pool and back into their own line, to be called again.', az: 'Müştərini kənara qoyulanlardan götürüb öz növbəsinə qaytarır ki, yenidən çağırılsın.', ru: 'Забирает клиента из отложенных и возвращает в его очередь, чтобы его вызвали снова.' },

  // ui/NoteHistory.tsx, ui/VisitFacts.tsx
  'floor.noteLabel': { en: 'Note for this visit', az: 'Bu müraciət üçün qeyd', ru: 'Заметка к обращению' },
  'floor.notePlaceholder': { en: 'e.g. wheelchair, needs the ground-floor counter', az: 'məs. əlil arabası, birinci mərtəbədəki pəncərə lazımdır', ru: 'напр. инвалидная коляска, нужно окно на первом этаже' },
  'floor.noteGone': { en: 'That visit has finished.', az: 'Bu müraciət bitib, ona görə qeydi silinib.', ru: 'Это обращение завершено, поэтому его заметки больше нет.' },
  'floor.noteNotSaved': { en: 'That note could not be saved.', az: 'Qeydi yadda saxlamaq mümkün olmadı.', ru: 'Не удалось сохранить заметку.' },
  'floor.charactersLeft': { en: '{n} characters left.', az: '{n} simvol qalıb.', ru: 'Осталось символов: {n}.' },
  // ui/NoteHistory.tsx: a visit's notes, "Desk 1 · Leyla · 10:42" then the text.
  'floor.notes': { en: 'Notes', az: '', ru: '' },
  'floor.notes.placeholder': { en: 'Add a note', az: '', ru: '' },
  'floor.notes.reception': { en: 'Reception', az: '', ru: '' },
  'floor.notes.edit': { en: 'Edit', az: '', ru: '' },
  'floor.notes.edited': { en: 'edited', az: '', ru: '' },
  'floor.notes.none': { en: 'No notes', az: '', ru: '' },

  // ui/MoveForm.tsx (Ruling 11: task 38 owns its wording — its signature changed
  // when whyNotMove and placementLabel took a language, and there was nothing
  // translated in it before this).
  'floor.nowMarker': { en: ' (now)', az: ' (indi)', ru: ' (сейчас)' },
  'floor.waitForAria': { en: 'Wait for', az: 'Gözləyəcəyi xidmət', ru: 'Ожидаемая услуга' },
  'floor.placeInLineAria': { en: 'Place in line', az: 'Növbədə yer', ru: 'Место в очереди' },
  'floor.move': { en: 'Move', az: 'Köçür', ru: 'Переместить' },
  'floor.moveTo': { en: 'To', az: '', ru: '' },
  'floor.moveTo.service': { en: 'Service', az: '', ru: '' },
  'floor.moveTo.desk': { en: 'Desk', az: '', ru: '' },
  // pages/Floor.tsx, the live dashboard (English only for now; az/ru dormant)
  'floor.dash.openN': { en: '{n} open', az: '', ru: '' },
  'floor.dash.hm': { en: '{h} h {m} m', az: '', ru: '' },
  'floor.dash.h': { en: '{h} h', az: '', ru: '' },
  'floor.dash.asked': { en: '{kind} request', az: '', ru: '' },
  'floor.all': { en: 'All branches', az: '', ru: '' },
  'floor.branches': { en: 'Branches', az: '', ru: '' },
  'floor.find': { en: 'Find branch', az: '', ru: '' },
  'floor.noBranches': { en: 'No branches', az: '', ru: '' },
  'floor.closed': { en: 'Closed', az: '', ru: '' },
  // The redesigned Live dashboard (lib/liveDash)
  'floor.db.workspace': { en: 'Workspace', az: '', ru: '' },
  'floor.db.title': { en: 'Live dashboard', az: '', ru: '' },
  'floor.db.subAll': { en: 'Every branch, right now', az: '', ru: '' },
  'floor.db.subBranch': { en: '{branch}, right now', az: '', ru: '' },
  'floor.db.subOpen': { en: '{branch}, open until {time}', az: '', ru: '' },
  'floor.db.subClosed': { en: '{branch}, closed', az: '', ru: '' },
  'floor.db.live': { en: 'Live', az: '', ru: '' },
  'floor.db.connecting': { en: 'Connecting…', az: '', ru: '' },
  'floor.db.offline': { en: 'Offline', az: '', ru: '' },
  'floor.db.updatedAt': { en: 'Updated {time}', az: '', ru: '' },
  'floor.db.auto': { en: 'Auto-refresh', az: '', ru: '' },
  'floor.db.refresh': { en: 'Refresh', az: '', ru: '' },
  'floor.db.searchN': { en: 'Search {n} branches', az: '', ru: '' },
  'floor.db.noMatch': { en: 'No branch matches', az: '', ru: '' },
  'floor.db.overSuffix': { en: '{n} over target', az: '', ru: '' },
  'floor.db.k.avgWait': { en: 'Avg. waiting', az: '', ru: '' },
  'floor.db.k.avgTx': { en: 'Average visit', az: '', ru: '' },
  'floor.db.k.desksOpen': { en: '{n, plural, one {# desk open} other {# desks open}}', az: '', ru: '' },
  'floor.db.k.longest': { en: 'Longest wait', az: '', ru: '' },
  'floor.db.k.sla': { en: 'Within target', az: '', ru: '' },
  'floor.db.c.all': { en: 'Across all branches', az: '', ru: '' },
  'floor.db.c.branch': { en: 'In this branch', az: '', ru: '' },
  'floor.db.c.served': { en: 'Visits completed', az: '', ru: '' },
  'floor.db.c.avgWait': { en: 'Customers waiting now', az: '', ru: '' },
  'floor.db.c.avgTx': { en: 'At the desk today', az: '', ru: '' },
  'floor.db.c.longest': { en: 'Single longest wait', az: '', ru: '' },
  'floor.db.c.sla': { en: 'Called, last 15 min', az: '', ru: '' },
  'floor.db.tip.waiting': { en: 'Customers with a ticket who have not been called yet.', az: '', ru: '' },
  'floor.db.tip.served': { en: 'Visits completed today. Missed and cancelled tickets are not counted.', az: '', ru: '' },
  'floor.db.tip.avgWait': { en: 'Average time the customers waiting now have been in the queue.', az: '', ru: '' },
  'floor.db.tip.avgTx': { en: 'Average time at the desk today, from Start serving to Finish.', az: '', ru: '' },
  'floor.db.tip.longest': { en: 'The longest wait among the customers still waiting.', az: '', ru: '' },
  'floor.db.tip.sla': { en: 'Share of customers called in the last 15 minutes within their service target.', az: '', ru: '' },
  'floor.db.waitingChart': { en: 'Waiting, last 4 hours', az: '', ru: '' },
  'floor.db.l.people': { en: 'People', az: '', ru: '' },
  'floor.db.l.min': { en: 'Min', az: '', ru: '' },
  'floor.db.l.target': { en: 'Target {n} min', az: '', ru: '' },
  'floor.db.every15': { en: 'Every 15 minutes, last 4 hours', az: '', ru: '' },
  'floor.db.nowSmall': { en: 'now', az: '', ru: '' },
  'floor.db.nowAxis': { en: 'Now', az: '', ru: '' },
  'floor.db.served': { en: 'Served', az: '', ru: '' },
  'floor.db.servedSub': { en: 'Visits completed per 15 minutes', az: '', ru: '' },
  'floor.db.byBranch': { en: 'Waiting by branch', az: '', ru: '' },
  'floor.db.byQueue': { en: 'Waiting by queue', az: '', ru: '' },
  'floor.db.waitingNow': { en: 'Customers waiting now', az: '', ru: '' },
  'floor.db.avgVsWarning': { en: 'Average wait vs warning time', az: '', ru: '' },
  'floor.db.warningTime': { en: 'Warning time', az: '', ru: '' },
  'floor.db.desksN': { en: '{n} desks', az: '', ru: '' },
  'floor.db.desksAll': { en: '{n} desks across all branches', az: '', ru: '' },
  'floor.db.desksOpenOf': { en: '{open} of {n} open', az: '', ru: '' },
  'floor.db.open': { en: 'open', az: '', ru: '' },
  'floor.db.d.serving': { en: 'Serving', az: '', ru: '' },
  'floor.db.d.calling': { en: 'Calling', az: '', ru: '' },
  'floor.db.d.free': { en: 'Free', az: '', ru: '' },
  'floor.db.d.break': { en: 'On break', az: '', ru: '' },
  'floor.db.d.closed': { en: 'Closed', az: '', ru: '' },
  'floor.db.attention': { en: 'Needs attention', az: '', ru: '' },
  'floor.db.items': { en: '{n, plural, one {# item} other {# items}}', az: '', ru: '' },
  'floor.db.allClear': { en: 'All clear', az: '', ru: '' },
  'floor.db.onTrackTitle': { en: 'Everything is on track', az: '', ru: '' },
  'floor.db.onTrackSub': { en: 'No queue without staff and nobody over the SLA', az: '', ru: '' },
  'floor.db.a.noStaff': { en: '{name}: {n} waiting, no desk serving this queue', az: '', ru: '' },
  'floor.db.a.noStaffSub': { en: 'Give an open desk a work profile with this queue', az: '', ru: '' },
  'floor.db.a.noDesk': { en: '{name}: {n} waiting, no desk open', az: '', ru: '' },
  'floor.db.a.noDeskSub': { en: 'Nobody is signed in at this branch', az: '', ru: '' },
  'floor.db.a.over': { en: '{n, plural, one {# customer is over the service SLA} other {# customers are over the service SLA}}', az: '', ru: '' },
  'floor.db.a.overSub': { en: 'Waiting longer than the target set for their service', az: '', ru: '' },
  'floor.db.a.near': { en: '{n, plural, one {# customer is close to the SLA} other {# customers are close to the SLA}}', az: '', ru: '' },
  'floor.db.a.nearSub': { en: 'Above 80% of the target wait — call them soon', az: '', ru: '' },
  'floor.db.a.long': { en: '{n, plural, one {# desk has been serving one customer for over 15 min} other {# desks have been serving one customer for over 15 min}}', az: '', ru: '' },
  'floor.db.a.show': { en: 'Show', az: '', ru: '' },
  'floor.db.a.bookings': { en: 'Bookings', az: '', ru: '' },
  'floor.db.a.lateSub': { en: 'Booked time passed, not arrived yet', az: '', ru: '' },
  'floor.db.a.alertSub': { en: 'Queue alert', az: '', ru: '' },
  'floor.db.a.request': { en: '{who} asks for {kind}', az: '', ru: '' },
  'floor.db.branchesSub': { en: 'Choose a branch to see its queues and desks', az: '', ru: '' },
  'floor.db.col.waiting': { en: 'Waiting', az: '', ru: '' },
  'floor.db.col.beingServed': { en: 'Being served', az: '', ru: '' },
  'floor.db.col.served': { en: 'Served', az: '', ru: '' },
  'floor.db.col.openDesks': { en: 'Open desks', az: '', ru: '' },
  'floor.db.col.avgWait': { en: 'Avg. wait', az: '', ru: '' },
  'floor.db.col.avgTx': { en: 'Avg. transaction', az: '', ru: '' },
  'floor.db.col.longest': { en: 'Longest', az: '', ru: '' },
  'floor.db.col.status': { en: 'Status', az: '', ru: '' },
  'floor.db.col.queue': { en: 'Queue', az: '', ru: '' },
  'floor.db.col.desk': { en: 'Desk', az: '', ru: '' },
  'floor.db.col.clerk': { en: 'Clerk', az: '', ru: '' },
  'floor.db.col.profile': { en: 'Profile', az: '', ru: '' },
  'floor.db.col.customer': { en: 'Customer', az: '', ru: '' },
  'floor.db.col.time': { en: 'Time', az: '', ru: '' },
  'floor.db.col.ticket': { en: 'Ticket', az: '', ru: '' },
  'floor.db.col.service': { en: 'Service', az: '', ru: '' },
  'floor.db.col.inLine': { en: 'In line', az: '', ru: '' },
  'floor.db.col.waited': { en: 'Waited', az: '', ru: '' },
  'floor.db.col.sla': { en: 'Target used', az: '', ru: '' },
  'floor.db.col.targetMet': { en: 'Target met', az: '', ru: '' },
  'floor.db.s.onTrack': { en: 'On track', az: '', ru: '' },
  'floor.db.s.overN': { en: '{n} over target', az: '', ru: '' },
  'floor.db.s.over': { en: 'Over target', az: '', ru: '' },
  'floor.db.s.near': { en: 'Close to SLA', az: '', ru: '' },
  'floor.db.s.noStaff': { en: 'No staff', az: '', ru: '' },
  'floor.db.queues': { en: 'Queues', az: '', ru: '' },
  'floor.db.queuesSub': { en: 'Open desks = desks signed in with a work profile that serves the queue', az: '', ru: '' },
  'floor.db.waitingList': { en: 'Waiting', az: '', ru: '' },
  'floor.db.lists': { en: 'Queues, desks and waiting customers', az: '', ru: '' },
  'floor.db.nobodyWaiting': { en: 'Nobody is waiting', az: '', ru: '' },
  'floor.db.noProfile': { en: 'No profile', az: '', ru: '' },
  'floor.db.journey': { en: 'Journey', az: '', ru: '' },
  'floor.db.j.issued': { en: 'Ticket issued', az: '', ru: '' },
  'floor.db.j.booked': { en: 'Booked time', az: '', ru: '' },
  'floor.db.j.firstCalled': { en: 'First called', az: '', ru: '' },
  'floor.db.j.lastCalled': { en: 'Last called', az: '', ru: '' },
  'floor.db.j.started': { en: 'Started {service}', az: '', ru: '' },
  'floor.db.j.ended': { en: 'Finished {service}', az: '', ru: '' },
  'floor.db.j.parked': { en: 'Set aside', az: '', ru: '' },
  'floor.db.j.missed': { en: 'Missed the call', az: '', ru: '' },
  'floor.db.j.now': { en: 'Now', az: '', ru: '' },
  'floor.db.j.viaToken': { en: 'Via token ({name})', az: '', ru: '' },
  'floor.db.j.other': { en: 'Changed', az: '', ru: '' },
  'floor.db.j.ticket.recalled': { en: 'Recalled', az: '', ru: '' },
  'floor.db.j.ticket.moved': { en: 'Moved', az: '', ru: '' },
  'floor.db.j.ticket.noted': { en: 'Note', az: '', ru: '' },
  'floor.db.j.ticket.customer_set': { en: 'Customer named', az: '', ru: '' },
  'floor.db.j.ticket.voided': { en: 'Removed', az: '', ru: '' },
  'floor.db.j.ticket.unparked': { en: 'Back in line', az: '', ru: '' },
} satisfies Record<`floor.${string}`, Phrase>
